import angular from "angular";

angular
    .module('app')
    .component('importUserForm', {
        template: require('./import-user-form.html'),
        controller: ['$http', 'ErrorResponseParser', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&',
        }
    });

function controller($http, ErrorResponseParser) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.user = $ctrl.resolve.user;

        $ctrl.firstName = $ctrl.user.first_name;
        $ctrl.lastName = $ctrl.user.last_name;
        $ctrl.patronymic = $ctrl.user.patronymic;

        $ctrl.errors = $ctrl.user.errors;

        if ($ctrl.user.phone) {
            $ctrl.phone = $ctrl.user.phone.slice(1);
        }
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        $ctrl.errors = [];

        $http
            .post('/admin/import-users/check-phone', {
                phone: '7' + $ctrl.phone
            })
            .then(
                function (response) {
                    $ctrl.loading = false;
                    let isValidPhone = response.data.is_valid_phone;
                    if (isValidPhone) {
                        $ctrl.close({
                            $value: {
                                first_name: $ctrl.firstName,
                                last_name: $ctrl.lastName,
                                patronymic: $ctrl.patronymic,
                                phone: '7' + $ctrl.phone,
                                is_valid_phone: true,
                                exists_user_id: response.data.exists_user_id
                            }
                        });
                    } else {
                        $ctrl.errors = ['Неверный номер телефона'];
                    }
                },
                function (error) {
                    $ctrl.loading = false;
                    ErrorResponseParser.parse(error);
                }
            );
    };

}
